import Form from "react-bootstrap/Form"

export default function Checkbox({ id, checked, disabled, onChange }) {
  return (
    <div className="Checkbox">
      <Form.Check
        className="Checkbox-control"
        checked={Boolean(checked)}
        disabled={disabled}
        type="checkbox"
        id={id}
        onChange={(event) => onChange(event.target.checked)}
      />
    </div>
  )
}